
<div class="fulfillmentLanding seed-return-wrapper sraCostSheetRetail">
  <div class="status-bar">
    For questions contact WinField United Customer Service at 1-855-494-6343 or WinFieldCustomerService&#64;landolakes.com
  </div>
  <div class="cppReturnsLandingPage margin-t10">
    <div class="row">
      <div class="col-9 margin-l0 TopSec">
        <h3>
          Retail Alliance Low Net Cost Sheet
        </h3>
      </div>
      <div class="col-3 text-right padding-t10">
        <div class="row">
          <div class="col-10">
            <img src="../assets/icon/svg/manage-reports.svg" (click)="selectFilter()" />
            <a href="Javascript:void(0);" style="color: #0b3f54; padding:15px;" (click)="selectFilter()">MANAGE REPORTS</a>
          </div>

          <div class="col-2" matTooltip="Show Glossary" matTooltipPosition="above" matTooltipClass="whiteFontCpp" (click)="showGlossary()"><i class="glossary-icon"></i></div>
        </div>
      </div>
    </div>
    <div class="form-sec padding-10">
      <div class="returnTop xs-pb-0">
        <h6 class="form-group-title d-flex justify-content-between xs-mb-0">
          Filter Options: <span (click)="togglePickup()" class="xs-expand-none xs-mr-20">
            <i class="fa angle" [ngClass]="isExpanded ? 'fa-angle-up' : 'fa-angle-down'"></i>
          </span>
        </h6>
        <div [@detailExpand]="isExpanded ? 'expanded' : 'collapsed'">
          <div class="row gx-3 padding-l15 padding-r15">
            <div class="col-md-3 margin-b10">
              <div class="addBorder">
                WinField United Product
                <app-dropdown-multiselect [itemsData]="productsList" [isShowValueInLabel]="true" [isInitiallySelectAll]="false" [selectInitialItem]="filters.products" (changemultiselect)="changeFilter($event, 'products')" [isSelectionKeepSameForSearch]="true"></app-dropdown-multiselect>
              </div>
            </div>
            <div class="col-md-3 margin-b10">
              <div class="addBorder">
                Vended HIF
                <app-dropdown-multiselect [itemsData]="yesNoList" [isInitiallySelectAll]="false" [selectInitialItem]="filters.vendedHIF" (changemultiselect)="changeFilter($event, 'vendedHIF')"></app-dropdown-multiselect>
              </div>
            </div>
            <div class="col-md-3 margin-b10">
              <div class="addBorder">
                Supplier
                <app-dropdown-multiselect [itemsData]="supplierList" [isInitiallySelectAll]="false" [selectInitialItem]="filters.suppliers" (changemultiselect)="changeFilter($event, 'suppliers')" [isSelectionKeepSameForSearch]="true"></app-dropdown-multiselect>
              </div>
            </div>
            <div class="col-md-3 margin-b10">
              <div class="addBorder">
                Product Description
                <app-dropdown-multiselect [itemsData]="productsDescriptionList" [isShowValueInLabel]="false" [isInitiallySelectAll]="false" [selectInitialItem]="filters.productsDescription" (changemultiselect)="changeFilter($event, 'productsDescription')" [isSelectionKeepSameForSearch]="true"></app-dropdown-multiselect>
              </div>
            </div>
            <div class="col-md-3 margin-b10">
              <div class="addBorder">
                Customer
                <app-dropdown-multiselect [itemsData]="customerList"
                                          bindLabel="accountName"
                                          bindValue="accountNumber"
                                          [isBindValueNumeric]="true"
                                          [isShowValueInLabel]="true"
                                          [isInitiallySelectAll]="false"
                                          [selectInitialItem]="filters.customers"
                                          (changemultiselect)="changeFilter($event, 'customers')"
                                           [isSelectionKeepSameForSearch]="true"></app-dropdown-multiselect>
              </div>
            </div>
            <div class="col-md-3 margin-b10">
              <div class="addBorder">
                Product Line
                <app-dropdown-multiselect [itemsData]="productLineList" [isInitiallySelectAll]="false" [selectInitialItem]="filters.productLines" (changemultiselect)="changeFilter($event, 'productLines')" [isSelectionKeepSameForSearch]="true"></app-dropdown-multiselect>
              </div>
            </div>

            <div class="col-md-3 margin-b10">
              <div class="addBorder padding-t0 padding-b0">
                <div class="" style="position:relative; top: 10px">Change Since Date</div>
                <mat-form-field class="wide95">
                  <input matInput [matDatepicker]="picker1" name="changeSinceDate" (focus)="picker1.open();"
                         readonly [(ngModel)]="filters.changeSinceDate" (dateChange)="changeFilter($event, 'changeSinceDate')">
                  <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                  <mat-datepicker #picker1></mat-datepicker>
                </mat-form-field>
              </div>
            </div>
            <div class="col-md-3 margin-b10">
              <div class="addBorder">
                Prepay Eligible
                <app-dropdown-multiselect [itemsData]="yesNoList" [isInitiallySelectAll]="false" [selectInitialItem]="filters.prepayEligible" (changemultiselect)="changeFilter($event, 'prepayEligible')"></app-dropdown-multiselect>
              </div>
            </div>
            <div class="col-md-3 margin-b10">
              <div class="addBorder">
                Data Source
                <app-dropdown-multiselect [itemsData]="DataSourceList" [isInitiallySelectAll]="false" [selectInitialItem]="filters.dataSource" (changemultiselect)="changeFilter($event, 'dataSource')" [isSelectionKeepSameForSearch]="true"></app-dropdown-multiselect>
              </div>
            </div>
            <div class="col-md-3 m-auto">
              <div class="addBorder">
                <span>Price Change Indicator </span>
                <mat-checkbox #SingleCheck class="custom-checkbox"
                              [(ngModel)]="filters.priceChangeIndicator"
                              (change)="changeFilter($event, 'priceChangeIndicator')"></mat-checkbox>
              </div>
            </div>
            <div class="col-md-3 margin-b10">
              <div class="addBorder">
                Product Group
                <app-dropdown-multiselect [itemsData]="productCategoryList" [isInitiallySelectAll]="false" [selectInitialItem]="filters.productCategories" (changemultiselect)="changeFilter($event, 'productCategories')" [isSelectionKeepSameForSearch]="true"></app-dropdown-multiselect>
              </div>
            </div>
            <div class="col-md-3">

            </div>
            <div class="col-md-3">

            </div>
          </div>
          </div>
      </div>
          <div class="row">
            <div class="col-6 padding-l30 padding-r0 padding-t5">
              <div class="row">

                <div class="col-3 padding-t5">
                  <p *ngIf="selectedTabIndex === 0 && currentSraFilter.filterDescription">REPORT NAME: {{currentSraFilter.filterDescription}}</p>
                  <p *ngIf="selectedTabIndex === 1 && currentSummaryFilter.filterDescription">REPORT NAME: {{currentSummaryFilter.filterDescription}}</p>
                </div>
                <div class="col-4 padding-t5">
                  <p *ngIf="selectedTabIndex === 0 && currentSraFilter.filterDescription">
                    LAST RUN DATE: {{(currentSraFilter.lastRunByTimeStamp || currentSraFilter.createTimeStamp) | date: 'MM/dd/yyyy'}}
                  </p>
                  <p *ngIf="selectedTabIndex === 1 && currentSummaryFilter.filterDescription">
                    LAST RUN DATE: {{(currentSummaryFilter.lastRunByTimeStamp || currentSummaryFilter.createTimeStamp) | date: 'MM/dd/yyyy'}}
                  </p>
                </div>
                <div class="col-5 padding-r30">
                  <button mat-raised-button class="btns margin-r10 w100" color="primary" (click)="editFilter()" *ngIf="( selectedTabIndex === 0 && ((currentSraFilter.userReportFilterId || !(currentSraFilter.userReportFilterId)) && currentSraFilter.filterDescription)) || ( selectedTabIndex === 1 && ((currentSummaryFilter.userReportFilterId || !(currentSummaryFilter.userReportFilterId)) && currentSummaryFilter.filterDescription))">Edit Report</button>
                  <button mat-raised-button class="btns margin-r10 w100" color="primary" (click)="save()" *ngIf="( selectedTabIndex === 0 && currentSraFilter.filterDescription ) || ( selectedTabIndex === 1 && currentSummaryFilter.filterDescription )">Save</button>
                </div>
              </div>
            </div>
            <div class="col-6" style="padding-right: 45px !important">
              <div class="row justify-content-end">
                <div class="col-3 padding-r0">
                  <button mat-raised-button class="btns w-100 margin-t5" [ngClass]="isSraCostSheetAccess=='Y' && selectedTabIndex == 0 ?'':'d-none'" [disabled]="costSheetDataList.length <= 0" (click)="navigatePriceSimulation()">Price Simulation</button>
                </div>
                <div class="col-3 padding-r0">
                  <button mat-raised-button class="btns w-100 export-button margin-t5" color="primary" (click)="addFilter()">Create Report</button>
                </div>

                <div class="col-3 padding-r0">
                  <button mat-raised-button class="btns w-100 export-button margin-t5" [disabled]="isSraCostSheetAccess!='Y' && isSraCostSheetSummaryAccess!='Y'" (click)="GetGridData(); togglePickup();">Get Data</button>
                </div>
                <div class="col-3 padding-r0">
                  <button mat-raised-button class="btns w-100 export-button margin-t5" [disabled]="isSraCostSheetAccess!='Y' && isSraCostSheetSummaryAccess!='Y'" [matMenuTriggerFor]="menu">Export</button>
                  <mat-menu #menu="matMenu" xPosition="after" class="matDropDownMenu mainNavDropDown report-export-btn">
                    <button mat-menu-item (click)="exportData()">Full Data</button>
                    <button mat-menu-item *ngIf="hasSraCostSheetTemplate && isSraCostSheetAccess==='Y' && selectedTabLebal == '1'" (click)="downloadTemplate(1)">Template</button>
                    <button mat-menu-item *ngIf="hasSraCostSheetSummaryTemplate && isSraCostSheetSummaryAccess==='Y' && selectedTabLebal == '2'" (click)="downloadTemplate(2)">
                      Template
                    </button>
                  </mat-menu>
                </div>
              </div>
            </div>
          </div>

      <div class="row margin-l0 margin-r0 productTableOuter"  [ngClass]="isExpanded ? '' : 'adjustTableHeight'">
        <div class="col-md-12 legend-outer margin-t10 sraTable">
          <mat-tab-group disableRipple [animationDuration]="'0ms'" class="matTabs prepayLandingTab" (selectedTabChange)="tabChanged($event)" [selectedIndex]="currentTab">
            <mat-tab label="1" *ngIf="isSraCostSheetAccess==='Y'">
              <ng-template mat-tab-label>
                <div class="tab-head">
                  <h4>
                    Cost Sheet
                  </h4>
                </div>
              </ng-template>
              <div class="fulfill-top-sec">
                <div class="row listing-action-items">
                  <div class="col-md-4">
                    <div class="row margin-r0 margin-b20">
                      <div class="col-md-12">
                        <div class="row">
                          <div class="col-md-2">
                            <div>
                              <mat-checkbox #Allcheck1 class="custom-checkbox select-all-check"
                                            (change)="enableAllCheckBoxes(Allcheck1._checked);"
                                            [checked]="costSheetDataList.length > 0 && (selectedCount > 0) && (selectedCount == costSheetDataList.length)"
                                            [indeterminate]="costSheetDataList.length > 0 && (selectedCount > 0) && (selectedCount < costSheetDataList.length)"
                                            [style.display]="disablecheckbox ? 'none' : 'block'"
                                            matTooltip="Select All Lines" [matTooltipPosition]="'above'" matTooltipClass="whiteFontCpp"
                                            data-testid="ddl-select-all-product"></mat-checkbox>
                            </div>

                                <div *ngIf="editToolKit">
                                  <div appClickOutside (clickOutside)="tabNode=''">
                                    <div>

                                      <span matTooltip="Add Selected Item to Favorites" [matTooltipPosition]="'above'" matTooltipClass="whiteFontCpp" style="padding: 22px 1px 0px 2px;">
                                        <i class="favourite-add" (click)="AddRemoveGlobalFavorite(true)"></i>
                                      </span>

                                      <span matTooltip="Remove Selected Item from Favorites" [matTooltipPosition]="'below'" matTooltipClass="whiteFontCpp" style="padding: 22px 1px 0px 2px;">
                                        <i class="favourite-remove" (click)="AddRemoveGlobalFavorite(false)"></i>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-8 text-right">
                        <!--<div class="display-ib text-right refreshIcon" (click)="resetGroupingColorFilters();" matTooltip="reset your grouping" [matTooltipPosition]="'above'"> <i class="reset-icon"></i></div>-->
                        <ul>
                          <li class="" matTooltip="Save Toggle Preference" (click)="saveSraToggleColumnSettings()" [matTooltipPosition]="'above'" matTooltipClass="whiteFontCpp">
                            <i class="fas fa-save"></i>
                          </li>
                        </ul>
                        <div class="display-ib wAuto">
                          <mat-paginator #costSheetPaginator [pageSize]="masterConstants.PAGE_SIZE_LARGE" [pageSizeOptions]="masterConstants.PAGE_SIZE_OPTIONS_LARGE"></mat-paginator>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="tableContainer activeReturnRequest" [ngClass]="isExpanded ? '' : 'adjustTableHeight'">
                    <table mat-table #coiTable [dataSource]="costSheetDataSource" matSort #coiSort matSortDirection="desc" class="matTables coiActiveTable">
                      <ng-container matColumnDef="customerNumber">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">
                          Customer Number
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" [attr.rowspan]="rowSpans[0][iRow].span"
                            [style.display]="rowSpans[0][iRow].span === 0 ? 'none' : ''" class="ml-0">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{row.customerNumber}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="customerName">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">
                          Customer Name
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" [attr.rowspan]="rowSpans[1][iRow].span"
                            [style.display]="rowSpans[1][iRow].span === 0 ? 'none' : ''" class="text-left">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{row.customerName}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="itemDescription">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column accName text-center">
                          Item Description
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" [attr.rowspan]="rowSpans[2][iRow].span"
                            [style.display]="rowSpans[2][iRow].span === 0 ? 'none' : ''" class="text-center" style="border-spacing:10px">

                          <mat-checkbox #SingleCheck class="custom-checkbox"
                                        [style.display]="'contents'"
                                        [disabled]="readOnlyAccess"
                                        (change)="enableCheckBoxSingle(SingleCheck._checked)"
                                        [(ngModel)]="row.isSelected"
                                        [attr.data-testid]="'ddl-specific-check_Cost_'+i"></mat-checkbox>

                          <span *ngIf="row.isFavorite" style="cursor:pointer" class="favIcon pl-2" (click)="AddRemoveFavoriteIndividual(row, false)"> <i class="fas fa-star" style="color: #0b3f54"></i></span>
                          <span *ngIf="!row.isFavorite" style="cursor:pointer" class="favIcon pl-2" (click)="AddRemoveFavoriteIndividual(row, true)"> <i class="far fa-star"></i></span>
                          {{row.itemDescription}}
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="winfieldProduct">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">
                          WinField United Product #
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" [attr.rowspan]="rowSpans[3][iRow].span"
                            [style.display]="rowSpans[3][iRow].span === 0 ? 'none' : ''" class="text-center">
                          <div class="order-info cursor-default-pointer text-center">
                            <p class="grower-name">
                              {{row.winfieldProduct}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="supplier">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">
                          Supplier
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{row.supplier}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="productLine">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">
                          Product Line
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{row.productLine}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="productGroup">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">
                          Product Group
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{row.productGroup}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="vendedHIF">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">
                          Vended HIF
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{row.vendedHIF}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="palletQuantity">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">
                          Pallet Quantity
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{row.palletQuantity}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="packageSize">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">
                          Package Size
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{row.packageSize}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="pricingUnit">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">
                          Pricing Unit
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{row.pricingUnit}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="rup">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">
                          RUP
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{row.rup}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="nonReturnable">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">
                          Non-Returnable
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{row.nonReturnable}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="priceChangeIndicator">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">
                          Price Change Indicator
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{row.priceChangeIndicator}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="priceEffectiveDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">
                          Price Effective Date
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{row.priceEffectiveDate | date: masterConstants.DATE_MMDDYYYY}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="termEffectiveDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">
                          Term Effective Date
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{row.termEffectiveDate | date: masterConstants.DATE_MMDDYYYY}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="nationalPrice">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center" (mouseenter)="findColumninvolment('nationalPrice')" [ngClass]=" coloumnToAddHeaderCss['nationalPrice'] ? 'changeTextColor' : '' ">
                          National Price
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center" [ngStyle]="row.nationalPriceChangeFlag ? {'background': '#FDCF35'}:'' ">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{amountValue(row.nationalPrice)}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="distributorList">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center" (mouseenter)="findColumninvolment('distributorList')" [matTooltip]="getToolTipValue('distributorList')" matTooltipPosition="above"
                            matTooltipClass="whiteFontCpp" [ngClass]=" coloumnToAddHeaderCss['distributorList'] ? 'changeTextColor' : '' ">
                          Distributor List
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center" [ngStyle]="row.distributorListChangeFlag ? {'background': '#FDCF35'}:'' ">
                          <div class="order-info cursor-default-pointer">
                            <p *ngIf="(row.vendedHIFAtCost == true && row.vendedHIF == 'Y')" class="grower-name">
                              {{amountValue(row.distributorList)}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="redemptionPrice">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">
                          Redemption Price
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{amountValue(row.redemptionPrice)}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="redemptionPriceMethodology">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">
                          Redemption Price Methodology
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{row.redemptionPriceMethodology}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="competitiveAllowancePc">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center" (mouseenter)="findColumninvolment('competitiveAllowancePc')" [ngClass]=" coloumnToAddHeaderCss['competitiveAllowancePc'] ? 'changeTextColor' : '' ">
                          Competitive Allowance %
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center" [ngStyle]="row.competitiveAllowancePCChangeFlag ? {'background': '#FDCF35'}:'' ">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{percentValue(row.competitiveAllowancePc)}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="specialPricePc">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center" (mouseenter)="findColumninvolment('competitiveAllowancePc')" [ngClass]=" coloumnToAddHeaderCss['specialPricePc'] ? 'changeTextColor' : '' ">
                          Special Price %
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center" [ngStyle]="row.specialPricePCChangeFlag ? {'background': '#FDCF35'}:'' ">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{percentValue(row.specialPricePc)}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="invoicePrice">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">
                          Invoice Price
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center" [ngStyle]="row.invoicePriceChangeFlag ? {'background': '#FDCF35'}:'' ">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{amountValue(row.invoicePrice)}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="manufacturerSurchargePc">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">
                          Manufacturer Surcharge %
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center" [ngStyle]="row.manufacturerSurchargePCChangeFlag ? {'background': '#FDCF35'}:'' ">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{percentValue(row.manufacturerSurchargePc)}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="manufacturerSurcharge">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center" [ngClass]=" coloumnToAddHeaderCss['manufacturerSurcharge'] ? 'changeTextColor' : '' ">
                          <mat-checkbox class="custom-checkbox"
                                        [style.display]="'contents'"
                                        [checked]="columnSelection.manufacturerSurcharge"
                                        (change)="columnCheckboxSelection('manufacturerSurcharge',$event)"> </mat-checkbox>
                          Manufacturer Surcharge $
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center" [ngStyle]="row.manufacturerSurchargeChangeFlag ? {'background': '#FDCF35'}:'' ">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{amountValue(row.manufacturerSurcharge)}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="invoicePricewithSurcharge">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">
                          Invoice Price with Surcharge
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center" [ngStyle]="row.invoicePricewithSurchargeChangeFlag ? {'background': '#FDCF35'}:'' ">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{amountValue(row.invoicePricewithSurcharge)}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="wholesaleRebatePcguidance">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center" (mouseenter)="findColumninvolment('wholesaleRebatePcguidance')"
                            [matTooltip]="getToolTipValue('wholesaleRebatePcguidance')" matTooltipPosition="above"
                            matTooltipClass="whiteFontCpp" [ngClass]=" coloumnToAddHeaderCss['wholesaleRebatePcguidance'] ? 'changeTextColor' : '' ">
                          Wholesale Rebate % (Guidance)
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center" [ngStyle]="row.wholesaleRebatePCGuidanceChangeFlag ? {'background': '#FDCF35'}:'' ">
                          <div class="order-info cursor-default-pointer">
                            <p *ngIf="(row.vendedHIFAtCost == true && row.vendedHIF == 'Y')" class="grower-name">
                              {{percentValue(row.wholesaleRebatePcguidance)}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="distributionCost">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center" (mouseenter)="findColumninvolment('distributionCost')" [matTooltip]="getToolTipValue('distributionCost')" matTooltipPosition="above"
                            matTooltipClass="whiteFontCpp" [ngClass]=" coloumnToAddHeaderCss['distributionCost'] ? 'changeTextColor' : '' ">
                          <mat-checkbox class="custom-checkbox"
                                        [style.display]="'contents'"
                                        [checked]="columnSelection.distributionCost"
                                        (change)="columnCheckboxSelection('distributionCost',$event)"></mat-checkbox>
                          Distribution Cost $
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{amountValue(row.distributionCost)}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="wuDeliveredCost">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center" [matTooltip]="getToolTipValue('wuDeliveredCost')" matTooltipPosition="above"
                            matTooltipClass="whiteFontCpp">
                          WU Delivered Cost
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{amountValue(row.wuDeliveredCost)}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="wuDeliveredCostPcOffNationalwoMfgSurcharge">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">WU Delivered Cost % Off National</th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{percentValue(row.wuDeliveredCostPcOffNationalwoMfgSurcharge)}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="wuDeliveredCostPcOffNationalwMfgSurcharge">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">WU Delivered Cost % Off National w/ Mfg Surcharge</th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{percentValue(row.wuDeliveredCostPcOffNationalwMfgSurcharge)}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="contractPrepayPc">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center" (mouseenter)="findColumninvolment('contractPrepayPc')" [matTooltip]="getToolTipValue('contractPrepayPc')" matTooltipPosition="above"
                            matTooltipClass="whiteFontCpp" [ngClass]=" coloumnToAddHeaderCss['contractPrepayPc'] ? 'changeTextColor' : '' ">
                          Contract Prepay %
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center" [ngStyle]="row.prepayPCChangeFlag ? {'background': '#FDCF35'}:'' ">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{percentValue(row.contractPrepayPc)}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="wuDeliveredCostwPrepay">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">WU Delivered Cost w/ Prepay</th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{amountValue(row.wuDeliveredCostwPrepay)}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="wuDeliveredCostwPrepayPCoffNational">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">WU Delivered Cost w/ Prepay % off National</th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{percentValue(row.wuDeliveredCostwPrepayPCoffNational)}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="srarebatePcguidance">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center" (mouseenter)="findColumninvolment('srarebatePcguidance')"
                            [matTooltip]="getToolTipValue('sraRebatePCGuidance')" matTooltipPosition="above"
                            matTooltipClass="whiteFontCpp" [ngClass]=" coloumnToAddHeaderCss['srarebatePcguidance'] ? 'changeTextColor' : '' ">
                          SRA Rebate % (Guidance)
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center" [ngStyle]="row.sRARebateGuidanceChangeFlag ? {'background': '#FDCF35'}:'' ">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{percentValue(row.srarebatePcguidance)}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="dividendPc">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">
                          Dividend %
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{percentValue(row.dividendPc)}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="retailBaseRebates">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">
                          National Mfg Published Rebate
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{percentValue(row.retailBaseRebates)}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="retailStockingRebate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">
                          <mat-checkbox class="custom-checkbox"
                                        [style.display]="'contents'"
                                        [checked]="columnSelection.retailStockingRebate"
                                        (change)="columnCheckboxSelection('retailStockingRebate',$event)"></mat-checkbox>
                          Retail Stocking Rebate
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                          <div class="order-info cursor-default-pointer">
                            <p *ngIf="row.retailStockingRebate > 0" class="grower-name">
                              {{percentValue(row.retailStockingRebate)}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="retailUnpublishedRebates">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">
                          <mat-checkbox class="custom-checkbox"
                                        [style.display]="'contents'"
                                        [checked]="columnSelection.retailUnpublishedRebates"
                                        (change)="columnCheckboxSelection('retailUnpublishedRebates',$event)"></mat-checkbox>
                          Retail Unpub Rebate
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                          <div class="order-info cursor-default-pointer">
                            <p *ngIf="row.retailUnpublishedRebates > 0" class="grower-name">
                              {{percentValue(row.retailUnpublishedRebates)}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="retailLocalRebate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">
                          <mat-checkbox class="custom-checkbox"
                                        [style.display]="'contents'"
                                        [checked]="columnSelection.retailLocalRebate"
                                        (change)="columnCheckboxSelection('retailLocalRebate',$event)"></mat-checkbox>
                          Retail Local Rebate
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                          <div class="order-info cursor-default-pointer">
                            <p *ngIf="row.retailLocalRebate > 0" class="grower-name">
                              {{percentValue(row.retailLocalRebate)}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="lowNetwoPrepay">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center" [ngClass]=" coloumnToAddHeaderCss['lowNetwoPrepay'] ? 'changeTextColor' : '' ">
                          Low Net w/o Prepay
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center" [ngStyle]="row.lowNetwoPrepayChangeFlag ? {'background': '#FDCF35'}:'' ">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{amountValue(row.lowNetwoPrepay)}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="lowNetwoPrepayPriceChange">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">
                          Price Change
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              <span *ngIf="row.lowNetwoPrepayPriceChange=='Increase'" class="d-inline-block upArrow">&#8679;</span>
                              <span *ngIf="row.lowNetwoPrepayPriceChange=='Decrease'" class="d-inline-block downArrow">&#8681;</span>
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="totDiscountOffNatlwoPrepay">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">
                          Tot Discount Off Natl w/o Prepay
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{percentValue(row.totDiscountOffNatlwoPrepay)}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="prepayEligible">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center" [matTooltip]="getToolTipValue('prepayEligible')" matTooltipPosition="above"
                            matTooltipClass="whiteFontCpp">
                          Prepay Eligible
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{row.prepayEligible}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="nationalPaymentTerms">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">
                          National Payment Terms
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{row.nationalPaymentTerms}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="currentAprpc">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center" [matTooltip]="getToolTipValue('currentAprpc')" matTooltipPosition="above"
                            matTooltipClass="whiteFontCpp">
                          Current APR %
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{percentValue(row.currentAprpc)}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="decAprpc">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center" [matTooltip]="getToolTipValue('decAprpc')" matTooltipPosition="above"
                            matTooltipClass="whiteFontCpp">
                          Dec APR %
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{percentValue(row.decAprpc)}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="juneAprpc">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center" [matTooltip]="getToolTipValue('juneAprpc')" matTooltipPosition="above"
                            matTooltipClass="whiteFontCpp">
                          June APR %
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{percentValue(row.juneAprpc)}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="prepayPc">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center" [matTooltip]="getToolTipValue('prepayPc')" matTooltipPosition="above"
                            matTooltipClass="whiteFontCpp">
                          Prepay %
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                          <div class="order-info cursor-default-pointer">
                            <p *ngIf="row.prepayPc > 0" class="grower-name">
                              {{percentValue(row.prepayPc)}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="lowNetwPrepay">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center" (mouseenter)="findColumninvolment('lowNetwPrepay')" [matTooltip]="getToolTipValue('lowNetwPrepay')" matTooltipPosition="above"
                            matTooltipClass="whiteFontCpp" [ngClass]=" coloumnToAddHeaderCss['lowNetwPrepay'] ? 'changeTextColor' : '' ">
                          Low Net w/ Prepay
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center" [ngStyle]="row.lowNetwPrepayChangeFlag ? {'background': '#FDCF35'}:'' ">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{amountValue(row.lowNetwPrepay)}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="pcoffNationalwPrepay">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">
                          % Off National w/ Prepay
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{percentValue(row.pcoffNationalwPrepay)}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="retailMarginT1">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">
                          Retail Margin - Tier 1
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                          <div class="order-info cursor-default-pointer">
                            <p *ngIf="row.retailMarginT1 > 0" class="grower-name">
                              {{percentValue(row.retailMarginT1)}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="retailMarginT2">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">
                          Retail Margin - Tier 2
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                          <div class="order-info cursor-default-pointer">
                            <p *ngIf="row.retailMarginT2 > 0" class="grower-name">
                              {{percentValue(row.retailMarginT2)}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="retailMarginT3">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">
                          Retail Margin - Tier 3
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                          <div class="order-info cursor-default-pointer">
                            <p *ngIf="row.retailMarginT3 > 0" class="grower-name">
                              {{percentValue(row.retailMarginT3)}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="retailMarginT1Price">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">
                          Retail Price - Tier 1
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{amountValue(row.retailMarginT1Price)}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="retailMarginT2Price">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">
                          Retail Price - Tier 2
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{amountValue(row.retailMarginT2Price)}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="retailMarginT3Price">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">
                          Retail Price - Tier 3
                        </th>
                        <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{amountValue(row.retailMarginT3Price)}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <tr mat-header-row *matHeaderRowDef="columnNames;sticky:true;"></tr>
                      <tr mat-row *matRowDef="let row; columns: columnNames;" [ngClass]="row.isRowHighlighted ? 'highlightRow':'' "></tr>
                    </table>
                    <div *ngIf="!costSheetDataList || costSheetDataList.length == 0" class="noDataMsg">
                      <p class="padding-b47">No Record Found.</p>
                    </div>
                  </div>
                </mat-tab>

                <mat-tab label="2" *ngIf="isSraCostSheetSummaryAccess==='Y'">
                  <div class="col-md-2">
                    <ng-template mat-tab-label>
                      <div class="tab-head">
                        <h4>
                          WU Delivered Cost
                        </h4>
                      </div>
                    </ng-template>
                  </div>

                  <div class="fulfill-top-sec">
                    <div class="row listing-action-items">
                      <div class="col-md-4">
                        <div class="row margin-r0 margin-b20">
                          <div class="col-md-12">
                            <div class="row">
                              <div class="col-md-2">
                                <div class="mobile-box">
                                  <mat-checkbox #Allcheck class="custom-checkbox select-all-check"
                                                (change)="enableAllCheckBoxes(Allcheck._checked);"
                                                [checked]="costSheetSummaryDataList.length > 0 && (selectedCountSummary > 0) && (selectedCountSummary == costSheetSummaryDataList.length)"
                                                [indeterminate]="costSheetSummaryDataList.length > 0 && (selectedCountSummary > 0) && (selectedCountSummary < costSheetSummaryDataList.length)"
                                                [style.display]="disablecheckbox ? 'none' : 'block'"
                                                matTooltip="Select All Lines" [matTooltipPosition]="'above'"
                                                data-testid="ddl-select-all-product-summary"></mat-checkbox>
                                </div>

                                <div *ngIf="editToolKit">
                                  <div appClickOutside (clickOutside)="tabNode=''">
                                    <div>
                                      <span matTooltip="Add Selected Item to Favorites" [matTooltipPosition]="'above'" matTooltipClass="whiteFontCpp" style="padding: 22px 1px 0px 2px;">
                                        <i class="favourite-add" (click)="AddRemoveGlobalFavorite(true)"></i>
                                      </span>

                                      <span matTooltip="Remove Selected Item from Favorites" [matTooltipPosition]="'below'" matTooltipClass="whiteFontCpp" style="padding: 22px 1px 0px 2px;">
                                        <i class="favourite-remove" (click)="AddRemoveGlobalFavorite(false)"></i>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-xl-8 col-lg-8 col-md-9 text-right smallPadLeft0 padding-r10">
                        <div class="display-ib wAuto">
                          <mat-paginator #costSheetSummaryPaginator [pageSize]="masterConstants.PAGE_SIZE_LARGE" [pageSizeOptions]="masterConstants.PAGE_SIZE_OPTIONS_LARGE"></mat-paginator>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="tableContainer activeReturnRequest" [ngClass]="isExpanded ? '' : 'adjustTableHeight'">
                    <table mat-table #returnRequestTable [dataSource]="costSheetSummaryDataSource" matSort #returnRequestSort matSortDirection="desc" class="matTables seedLossDraftTable">
                      <ng-container matColumnDef="customerNumber">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column text-center">Customer Number</th>
                        <td mat-cell *matCellDef="let element; let iRow = index" [attr.rowspan]="summaryRowSpans[0][iRow].span"
                            [style.display]="summaryRowSpans[0][iRow].span === 0 ? 'none' : ''" class="ml-0">
                          {{element.customerNumber}}
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="customerName">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column text-center">Customer Name</th>
                        <td mat-cell *matCellDef="let element; let iRow = index" [attr.rowspan]="summaryRowSpans[1][iRow].span"
                            [style.display]="summaryRowSpans[1][iRow].span === 0 ? 'none' : ''" class="ml-0">
                          {{element.customerName}}
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="itemDescription">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column text-center">Item Description</th>
                        <td mat-cell *matCellDef="let element; let iRow = index" [attr.rowspan]="summaryRowSpans[2][iRow].span"
                            [style.display]="summaryRowSpans[2][iRow].span === 0 ? 'none' : ''" class="text-center">

                          <mat-checkbox #SingleCheck class="custom-checkbox"
                                        [style.display]="'contents'"
                                        [disabled]="readOnlyAccess"
                                        (change)="enableCheckBoxSingle(SingleCheck._checked)"
                                        [(ngModel)]="element.isSelected"
                                        [attr.data-testid]="'ddl-specific-check_Summary_'+i"></mat-checkbox>

                          <span *ngIf="element.isFavorite" style="cursor:pointer" class="favIcon pl-2" (click)="AddRemoveFavoriteIndividual(element, false)"> <i class="fas fa-star" style="color: #0b3f54"></i></span>
                          <span *ngIf="!element.isFavorite" style="cursor:pointer" class="favIcon pl-2" (click)="AddRemoveFavoriteIndividual(element, true)"> <i class="far fa-star"></i></span>
                          {{element.itemDescription}}
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="winfieldProduct">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column text-center">WinField United Product #</th>
                        <td mat-cell *matCellDef="let element" class="text-center">
                          {{element.winfieldProduct}}
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="vendedHIF">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column text-center">Vended HIF</th>
                        <td mat-cell *matCellDef="let element" class="text-center">
                          {{element.vendedHIF}}
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="packageSize">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column text-center">
                          Package Size
                        </th>
                        <td mat-cell *matCellDef="let element" class="text-center">
                          {{element.packageSize}}
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="pricingUnit">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column text-center">
                          Pricing Unit
                        </th>
                        <td mat-cell *matCellDef="let element" class="text-center">
                          {{element.pricingUnit}}
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="nationalPrice">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column text-center">National Price</th>
                        <td mat-cell *matCellDef="let element" class="text-center" [ngStyle]="element.nationalPriceChangeFlag ? {'background': '#FDCF35'}:'' ">
                          {{amountValue(element.nationalPrice)}}
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="invoicePrice">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column text-center">Invoice Price</th>
                        <td mat-cell *matCellDef="let element" class="text-center" [ngStyle]="element.invoicePriceChangeFlag ? {'background': '#FDCF35'}:'' ">
                          {{amountValue(element.invoicePrice)}}
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="manufacturerSurcharge">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column text-center">Manufacturer Surcharge $</th>
                        <td mat-cell *matCellDef="let element" class="text-center" [ngStyle]="element.manufacturerSurchargeChangeFlag ? {'background': '#FDCF35'}:'' ">
                          {{amountValue(element.manufacturerSurcharge)}}
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="invoicePricewithSurcharge">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column text-center">Invoice Price with Surcharge</th>
                        <td mat-cell *matCellDef="let element" class="text-center" [ngStyle]="element.invoicePricewithSurchargeChangeFlag ? {'background': '#FDCF35'}:'' ">
                          {{amountValue(element.invoicePricewithSurcharge)}}
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="wuDeliveredCost">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column text-center" [matTooltip]="getToolTipValue('wuDeliveredCost')" matTooltipPosition="above"
                            matTooltipClass="whiteFontCpp">
                          WU Delivered Cost
                        </th>
                        <td mat-cell *matCellDef="let element" class="text-center">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{amountValue(element.wuDeliveredCost)}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="wuDeliveredCostPcOffInvoice">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column text-center" [matTooltip]="getToolTipValue4Summary('lowNetwoPrepay')" matTooltipPosition="above"
                            matTooltipClass="whiteFontCpp">
                          WU Delivered Cost % Off Invoice
                        </th>
                        <td mat-cell *matCellDef="let element" class="text-center">
                          {{percentValue(element.wuDeliveredCostPcOffInvoice)}}
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="wuDeliveredCostPcOffNationalwoMfgSurcharge">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column text-center">WU Delivered Cost % Off National</th>
                        <td mat-cell *matCellDef="let element" class="text-center">
                          {{percentValue(element.wuDeliveredCostPcOffNationalwoMfgSurcharge)}}
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="wuDeliveredCostPcOffNationalwMfgSurcharge">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column text-center">WU Delivered Cost % Off National w/ Mfg Surcharge</th>
                        <td mat-cell *matCellDef="let element" class="text-center">
                          {{percentValue(element.wuDeliveredCostPcOffNationalwMfgSurcharge)}}
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="contractPrepayPc">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column text-center" [matTooltip]="getToolTipValue4Summary('contractPrepayPc')" matTooltipPosition="above"
                            matTooltipClass="whiteFontCpp">
                          Contract Prepay %
                        </th>
                        <td mat-cell *matCellDef="let element" class="text-center" [ngStyle]="element.prepayPCChangeFlag ? {'background': '#FDCF35'}:'' ">
                          {{percentValue(element.contractPrepayPc)}}
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="wuDeliveredCostwPrepay">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column text-center">WU Delivered Cost w/ Prepay</th>
                        <td mat-cell *matCellDef="let element" class="text-center">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{amountValue(element.wuDeliveredCostwPrepay)}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="wuDeliveredCostwPrepayPCoffNational">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">WU Delivered Cost w/ Prepay % off National</th>
                        <td mat-cell *matCellDef="let element" class="text-center">
                          <div class="order-info cursor-default-pointer">
                            <p class="grower-name">
                              {{percentValue(element.wuDeliveredCostwPrepayPCoffNational)}}
                            </p>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="dividendPc">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column text-center" matTooltipPosition="above">
                          Dividend %
                        </th>
                        <td mat-cell *matCellDef="let element" class="text-center">
                          {{percentValue(element.dividendPc)}}
                        </td>
                      </ng-container>
                      <tr mat-header-row *matHeaderRowDef="costSheetSummaryColumnNames;sticky:true;"></tr>
                      <tr mat-row *matRowDef="let row; columns: costSheetSummaryColumnNames;" [ngClass]="row.isRowHighlighted ? 'highlightRow':'' "></tr>
                    </table>
                    <div *ngIf="!costSheetSummaryDataList || costSheetSummaryDataList.length == 0" class="noDataMsg">
                      <p class="padding-b47">No Record Found.</p>
                    </div>
                  </div>
                </mat-tab>
              </mat-tab-group>
            </div>
          </div>
        </div>
      </div>
    </div>
